import { produce } from 'immer'
import type { State } from '../../typings'
import type { ActivitySummaryTopStatsDTO } from '../../../typings'

export const setActivitySummaryStatsProducer = produce<
  State,
  [ActivitySummaryTopStatsDTO]
>((draft, payload) => {
  draft.statsState.data = payload
})
